import React from 'react';
import PropTypes from 'prop-types';
import {UI, UploadTutorial} from 'components';
import * as Actions from 'actions';
import {connect} from 'react-redux';
import {ProgressBar} from 'components';
import {Modal} from 'react-bootstrap';
import { callApi } from '@hailtrace/client-api';

class Upload extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Upload';
        this.state = {
            fileName : null,
            error : null,
            uploading: false,
            progress : 0,
            show_demo_modal : true
        }

        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
    }

    handleFileSelect( event ) {
        var formObject = new FormData();
        var file = event.target.files[0];
        formObject.append('csv', file, file.name);
        var ext = file.name.split('.');
        if(file.type == 'text/csv' || (ext[ext.length-1] == 'csv')) {
            this.setState({fileName : file.name, formObject })
        }
        else {
            this.setState({fileName : "That file type isn't supported.", formObject : null});
        }
    }
    componentWillMount() {

        if(!this.props.hasPermission('/Account Management/Clients/Upload/')) {
            this.context.router.goBack();
        }

    }
    handleUpload( event ) {
        var {formObject}  = this.state;

        // TODO: extract to actions
        if(formObject) {
          this.setState({uploading : true});
          callApi('POST', '/clients/upload', formObject, undefined)
            .then(data => {
              this.setState({error : null});
              this.setState({progress : 1}, () => setTimeout(() => {
                  this.setState({uploading: false});
                  this.context.router.push('/clients');
              }, 1000));
            })
            .catch(error => {
              this.props.notify(error);
              this.setState({uploading:false});
            });
        }
    }
    render() {
        var uploadClassName = (this.state.formObject && !this.state.uploading) ? "" : " disabled";
        return (
        	<UI.Container title="Upload Clients">
        		<Modal
	        		bsSize='lg'
        			show={this.state.show_demo_modal}
        			onHide={() => {this.setState({show_demo_modal : false})}}
        		>
        			<UploadTutorial hide={() => {this.setState({show_demo_modal : false})}}/>
        		</Modal>

                <p>
                	<span
                  	className='btn btn-default'
                  	onClick={() => {this.setState({show_demo_modal : true})}}
                  	>
                  	Click Here
                  </span>
                  {' '}for a brief tutorial on uploading your clients.
                </p>
                <p className="well">{this.state.fileName ? this.state.fileName : "No File Selected."}</p>
                {(()=>{
                  if(this.state.uploading)
                    return <div className="row"><p>Uploading...</p><ProgressBar percent={this.state.progress} /></div>
                })()}
                <form id="upload-form">
                  <div className="row">
                      <div className="col-xs-12 col-sm-offset-4 col-sm-8 col-md-offset-6 col-md-6">
                        <div className="row">
                          <div className="col-xs-12 col-md-6 mb-sm">
                            <label className="btn btn-block btn-default" for="file">Select a File
                              <input onChange={this.handleFileSelect} className="hidden" name="file" type="file" />
                            </label>
                          </div>
                          <div className="col-xs-12 col-md-6">
                            <div onClick={(e) => {
                              if(!this.state.uploading)
                                this.handleUpload(e);
                            }} disabled={this.state.uploading} className={"btn btn-block btn-success" + uploadClassName}><i className="fa fa-arrow-up"></i> Upload</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
	        	</UI.Container>
        );
    }
}

var mapStateToProps = function(state) {
    var {
        connection
    } = state;

    return {
        connection
    }
}

Upload.contextTypes = {
    router : PropTypes.object
}

export default connect(mapStateToProps, Actions)(Upload);



// WEBPACK FOOTER //
// ./src/browser/components/clients/uploadClient.js